import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    color: zeplinColor.BasicBlack,
    cursor: 'pointer',
    borderRadius: '16px',
    padding: '16px',
    gap: '16px',
    border: `1px solid ${zeplinColor.Neutral5}`,
    backgroundColor: zeplinColor.Neutral1,
    transition: 'all ease 0.3s',
    ':hover': {
      border: `1px solid ${zeplinColor.BasicBlack}`,
    },
  },

  cardBody: { display: 'flex', flexDirection: 'column', gap: '8px' },

  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '8px',
  },

  title: {
    color: zeplinColor.BasicBlack,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  optionsMenu: {
    padding: '3px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    ':hover': {
      backgroundColor: zeplinColor.Neutral5,
      cursor: 'pointer',
    },
    gap: '4px',
  },

  clientCompanyContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '4px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },

  clientAvatar: { width: '24px', height: '24px' },

  dotDivider: {
    width: '5px',
    height: '5px',
    borderRadius: '100%',
    flexShrink: 0,
    backgroundColor: zeplinColor.BasicBlack,
  },

  typeValueContainer: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  chip: {
    height: '22px',
    '& .MuiChip-label': {
      padding: '4px 8px',
    },
  },

  divider: { borderColor: zeplinColor.Neutral5 },

  metaSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },

  userInfo: { display: 'inline-flex', gap: '4px', alignItems: 'center' },

  statusIndicator: { display: 'inline-flex', alignItems: 'center', gap: '8px' },

  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '100%',
  },
};
